var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyembedlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1911 7.30146L3.59111 12.2148L10.2156 17.1281C10.6556 17.4459 10.7289 18.057 10.4111 18.497C10.2156 18.7659 9.92222 18.8881 9.62889 18.8881C9.43333 18.8881 9.21333 18.8148 9.04222 18.6926L1.39111 13.0215C1.14667 12.8259 1 12.5326 1 12.2392C1 12.2148 1 12.2148 1 12.1903C1 12.1659 1 12.1659 1 12.1415C1 11.8481 1.14667 11.5548 1.39111 11.3592L9.01778 5.68813C9.45778 5.37035 10.0689 5.46813 10.3867 5.88368C10.7289 6.37257 10.6311 6.98368 10.1911 7.30146ZM23 12.2148C23 12.1903 23 12.1903 23 12.1659C23 11.8726 22.8533 11.5792 22.6089 11.3837L14.9578 5.73702C14.5178 5.41924 13.9067 5.51702 13.5889 5.93257C13.2711 6.37257 13.3689 6.98368 13.7844 7.30146L20.4089 12.2148L13.8089 17.1281C13.3689 17.4459 13.2956 18.057 13.6133 18.497C13.8089 18.7659 14.1022 18.8881 14.3956 18.8881C14.5911 18.8881 14.8111 18.8148 14.9822 18.6926L22.6089 13.0215C22.8533 12.8259 23 12.5326 23 12.2392C23 12.2392 23 12.2392 23 12.2148Z",
    fill: "#8493B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyembedlink);
export default __webpack_public_path__ + "static/media/copyembedlink.02a369ac20a67b898d2d980135a79c44.svg";
export { ForwardRef as ReactComponent };